import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/learner/ui/Button'
import { useFocusTrap } from '@/hooks/useFocusTrap'

interface Props {
  onConfirm: () => void
}

export function WrongReviewIntroDialog({ onConfirm }: Props) {
  const { t } = useTranslation('learner')
  const dialogRef = useRef<HTMLDivElement | null>(null)
  useFocusTrap(dialogRef, true)

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="wrong-review-intro-title"
      aria-describedby="wrong-review-intro-message"
    >
      <div
        ref={dialogRef}
        className="flex w-full max-w-[360px] flex-col items-start gap-6 rounded-[24px] bg-lc-bg-primary px-8 pt-8 pb-6 shadow-[0_8px_12px_rgba(0,0,0,0.12)]"
      >
        <div className="flex w-full flex-col items-center gap-3 text-center text-lc-text-primary">
          <h2 id="wrong-review-intro-title" className="w-full text-lc-v3-h4 font-bold">
            {t('learn.wrongReviewIntro.title')}
          </h2>
          <p id="wrong-review-intro-message" className="w-full text-lc-v3-body-1 font-normal">
            {t('learn.wrongReviewIntro.message')}
          </p>
        </div>
        <div className="flex w-full items-center justify-center">
          <Button variant="primary" size="M" onClick={onConfirm}>
            {t('learn.wrongReviewIntro.confirm')}
          </Button>
        </div>
      </div>
    </div>
  )
}
